import { FC, useMemo } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import { State } from 'redux/initialState';
import { useGetActualSociety } from 'hooks/useGetActualSociety';

import menuTypes from 'constants/menuTypes';

import Page from 'modules/_shared/components/Pages/Page';
import Breadcrumb, {
  BreadcrumbItem,
} from 'modules/_shared/components/Breadcrumb';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';

import '../../styles/Trading.scss';
import EquityMarketTermsByDefault from './components/EquityMarketTermsByDefault';
import EquityMarketTermsByTemplate from './components/EquityMarketTermsByTemplate';

const EquityMarketTerms: FC = () => {
  const { t } = useTranslate();
  const { societyId } = useParams<{ societyId: string }>();
  const location = useLocation();

  const actualSociety = useSelector(
    ({ society }: State) => society?.actualSociety
  );

  useGetActualSociety(societyId);
  useGetMenu(menuTypes.NULL);

  const queryString = location.search || '';
  const termsTemplateId =
    actualSociety?.templates?.equityMarketTermsAndConditions;
  const hasTermsAndConditionsTemplate = !!termsTemplateId;

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      { label: t('Dashboard'), to: '/' },
      {
        label: actualSociety?.name || '',
        to: `/sociedad/${societyId}`,
      },
      {
        label: t('EquityMarket'),
        to: `/mercado-de-acciones/${societyId}${queryString}`,
      },
      { label: t('OfferConditions'), isActive: true },
    ],
    [t, actualSociety?.name, societyId, queryString]
  );

  return (
    <Page id="equity-market-terms-page">
      <div className="nk-block-head-content mb-3">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="nk-block doc-condiciones">
        <div className="nk-block-head nk-block-head-sm mb-4">
          <h4 className="nk-block-title page-title mt-2 mb-1">
            {t('OfferConditionsPageTitle')}
          </h4>
          <p className="text-soft">{t('OfferConditionsPageDescription')}</p>
        </div>

        {hasTermsAndConditionsTemplate && termsTemplateId ? (
          <EquityMarketTermsByTemplate templateId={termsTemplateId} />
        ) : (
          <EquityMarketTermsByDefault />
        )}

        <div className="mt-4">
          <GoBackButton icon="ni-arrow-left" />
        </div>
      </div>
    </Page>
  );
};

export default EquityMarketTerms;
